import { render } from "./PageDoesNotExist.vue?vue&type=template&id=5614c8a7"
import script from "./PageDoesNotExist.vue?vue&type=script&lang=js"
export * from "./PageDoesNotExist.vue?vue&type=script&lang=js"

import "./PageDoesNotExist.vue?vue&type=style&index=0&id=5614c8a7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__